const fr = {
  nav: {
    features: "Fonctionnalités",
    dashboard: "Dashboard",
    howItWorks: "Comment ça marche",
    download: "Télécharger",
    login: "Connexion",
  },

  hero: {
    badge: "Gestion des notes de frais pour les entreprises",
    title: "La gestion de notes de frais,\nsimplifiée.",
    description:
      "Scannez, soumettez, suivez. TicketBox s'occupe du reste — du justificatif de l'employé jusqu'au remboursement par le comptable.",
    descriptionSecondary:
      "Photographiez votre ticket et laissez l'OCR et l'IA remplir votre note de frais à votre place, puis suivez sa validation et son remboursement en toute transparence.",
    ctaPrimary: "Télécharger l'application",
    ctaSecondary: "Voir comment ça marche",
    mockupAlt: "Écran d'accueil de l'application mobile TicketBox",
  },

  scan: {
    tag: "SCAN INTELLIGENT DE TICKETS",
    title: "Laissez l'IA remplir vos notes de frais",
    description:
      "Photographiez votre ticket et TicketBox extrait automatiquement le montant, la date et le commerçant grâce à l'OCR et à l'IA — sans saisie manuelle.",
    bullets: [
      "Extraction instantanée du texte par OCR",
      "Détection des champs par IA",
      "Modifiable avant l'envoi",
    ],
    resultLabel: "Résultat",
    result: "Moins de paperasse, des notes de frais plus rapides.",
    mockupAlt: "Scan intelligent d'un ticket dans l'application TicketBox",
  },

  workflow: {
    tag: "PROCESSUS SIMPLE ET TRAÇABLE",
    title: "Comment ça marche",
    description:
      "Chaque dépense suit un parcours clair et transparent — de la soumission au remboursement.",
    steps: [
      {
        title: "Soumettre",
        description:
          "L'employé photographie son ticket et soumet la dépense en quelques secondes.",
      },
      {
        title: "Valider",
        description:
          "Le comptable ou l'expert-comptable approuve la dépense, ou la rejette avec une note explicative.",
      },
      {
        title: "Rembourser",
        description:
          "Une fois remboursée par l'entreprise, la dépense est archivée avec son historique complet.",
      },
    ],
  },

  dashboard: {
    tag: "DASHBOARD WEB",
    title: "Gérez les dépenses de votre entreprise depuis un seul écran",
    description:
      "Comptables et responsables disposent d'un dashboard web dédié pour examiner, valider ou rejeter les dépenses, et suivre les remboursements — en complément de l'application mobile.",
    homeAlt: "Vue d'ensemble du dashboard web TicketBox",
    expensesAlt: "Écran de gestion des dépenses dans le dashboard web TicketBox",
    zoomHint: "Cliquer pour agrandir",
  },

  download: {
    title: "Téléchargez l'application",
    description:
      "Conçu pour les entreprises et leurs comptables : rôles, processus de validation et historique complet, de l'employé jusqu'à l'expert-comptable externe.",
    badgeAlt: "Disponible sur Google Play",
  },

  footer: {
    dashboardLink: "Dashboard",
    privacyLink: "Politique de confidentialité",
  },

  privacy: {
    title: "Politique de confidentialité TicketBox",
    effectiveDateLabel: "Date d'entrée en vigueur :",
    effectiveDate: "13 juillet 2026",
    backLink: "← Retour",
    sections: [
      {
        title: "1. Introduction",
        body: "La présente Politique de confidentialité décrit comment TicketBox collecte, utilise et protège vos données personnelles lorsque vous utilisez l'application mobile TicketBox, le dashboard web TicketBox et ce site. En utilisant le service, vous reconnaissez avoir pris connaissance de cette politique.",
      },
      {
        title: "2. Responsable du traitement",
        body: "Le responsable du traitement des données personnelles est TicketBox, exploité par Ygalaad. Pour toute question relative à vos données personnelles, vous pouvez nous contacter à support@ygalaad.com.",
      },
      {
        title: "3. Données que nous collectons",
        body: "Nous pouvons collecter les catégories de données suivantes : informations de compte (nom, prénom, adresse e-mail, mot de passe chiffré et numéro de téléphone le cas échéant, nécessaires à la création de votre compte) ; données professionnelles (votre rattachement à une entreprise, votre rôle — employé, comptable, responsable, expert-comptable externe — et votre responsable hiérarchique) ; données de notes de frais (montants, dates, catégories, commerçants, notes, statuts de validation et photos de tickets importées ou prises via la caméra) ; et données techniques (jetons d'authentification, identifiants de session, adresse IP, type d'appareil, version de l'application et journaux d'erreur, nécessaires au bon fonctionnement et à la sécurité du service).",
      },
      {
        title: "4. Finalités du traitement",
        body: "Vos données sont traitées pour : créer et gérer votre compte, et vous attribuer le rôle correspondant au sein de votre entreprise ; permettre la saisie, la soumission et le suivi de vos notes de frais ; extraire automatiquement les informations de vos justificatifs ; soumettre les dépenses à validation, rejet ou remboursement au sein de votre organisation ; assurer la sécurité, la fiabilité et la maintenance du service ; et répondre à vos demandes de support.",
      },
      {
        title: "5. Base légale",
        body: "Le traitement de vos données repose sur l'exécution du contrat liant TicketBox à son utilisateur, l'intérêt légitime de TicketBox à assurer la sécurité et l'amélioration du service, et, le cas échéant, le respect d'obligations légales applicables en matière de comptabilité ou de gestion des dépenses professionnelles.",
      },
      {
        title: "6. Destinataires des données",
        body: "Vos données de notes de frais (y compris les photos de tickets) sont accessibles aux administrateurs de votre organisation disposant d'un rôle autorisé — comptable, responsable ou expert-comptable externe — aux fins de validation, de rejet ou de remboursement des dépenses. Elles peuvent également être traitées par nos prestataires techniques (hébergement, infrastructure) strictement dans la mesure nécessaire à la fourniture du service, sous contrat de confidentialité. Nous ne vendons pas vos données personnelles à des tiers.",
      },
      {
        title: "7. Durée de conservation",
        body: "Vos données sont conservées pendant la durée de votre utilisation du service, puis archivées ou supprimées conformément aux obligations légales applicables et aux règles de conservation définies par votre organisation. Les données d'un compte inactif peuvent être supprimées après une période d'inactivité prolongée, sous réserve des délais légaux. Vous pouvez également demander la suppression de votre compte et de vos données à tout moment en contactant le responsable de votre entreprise ou directement Ygalaad.",
      },
      {
        title: "8. Vos droits",
        body: "Conformément au Règlement général sur la protection des données (RGPD), vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation du traitement, de portabilité et d'opposition concernant vos données personnelles. Vous pouvez exercer ces droits en écrivant à support@ygalaad.com. Vous avez également le droit d'introduire une réclamation auprès de la CNIL ou de toute autorité de protection des données compétente.",
      },
      {
        title: "9. Sécurité",
        body: "TicketBox met en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, perte, altération ou divulgation, notamment une authentification chiffrée (jetons JWT avec rafraîchissement sécurisé) et des communications chiffrées avec nos serveurs. L'accès à la caméra et à la galerie photo n'est sollicité que lorsque vous choisissez d'importer ou de photographier un justificatif. Aucune méthode de transmission ou de stockage ne peut être garantie totalement sécurisée.",
      },
      {
        title: "10. Confidentialité des mineurs",
        body: "Le service est destiné à un usage professionnel et ne s'adresse pas aux personnes de moins de 16 ans. Nous ne collectons pas sciemment de données concernant des mineurs.",
      },
      {
        title: "11. Modifications de cette politique",
        body: "TicketBox se réserve le droit de modifier la présente Politique de confidentialité à tout moment. La date d'entrée en vigueur indiquée en haut de cette page reflète la dernière révision. L'utilisation continue du service après une modification vaut acceptation de la politique mise à jour.",
      },
      {
        title: "12. Nous contacter",
        body: "Pour toute question relative à cette Politique de confidentialité ou à vos données personnelles, contactez-nous à : support@ygalaad.com — Ygalaad, 230 Route des Dolines, 06560 Valbonne, France.",
      },
    ],
  },
};

export default fr;
